// Optional sound effects — OFF by default, switched on in Profile ("Sound effects").
// Tones are synthesised with the Web Audio API (no audio files). Nothing plays while the tab is
// hidden or before the learner turns sound on. Preference: learner store `prefs-sound` (true/false).
// Tests can set window.__RZ_SOUND_LOG__ = [] to record which sounds were requested.
export const SOUND_KEY = 'prefs-sound';
let store = null;
let ctx = null;
let lastTick = 0;

export function initSound(learnerStore) { store = learnerStore; }
export const soundOn = () => { try { return store?.get(SOUND_KEY, false) === true; } catch { return false; } };
export function setSound(on) { store?.set(SOUND_KEY, !!on); if (on) play('chime'); }

// name → list of [frequency Hz, start s, duration s, type, gain]
const SOUNDS = {
  tick: [[1800, 0, 0.018, 'square', 0.025]],
  chime: [[880, 0, 0.12, 'sine', 0.12], [1318.5, 0.09, 0.22, 'sine', 0.1]],
  wrong: [[220, 0, 0.14, 'triangle', 0.09], [196, 0.1, 0.18, 'triangle', 0.08]],
  levelup: [[523.25, 0, 0.12, 'triangle', 0.1], [659.25, 0.1, 0.12, 'triangle', 0.1], [783.99, 0.2, 0.12, 'triangle', 0.1], [1046.5, 0.3, 0.3, 'sine', 0.12]],
  medal: [[523.25, 0, 0.14, 'sine', 0.1], [659.25, 0.12, 0.14, 'sine', 0.1], [783.99, 0.24, 0.14, 'sine', 0.1], [1046.5, 0.36, 0.2, 'sine', 0.12], [1318.5, 0.52, 0.45, 'sine', 0.1]],
};

/** Play one of: tick, chime, wrong, levelup, medal (no-op when sound is off). */
export function play(name) {
  if (typeof window === 'undefined' || !SOUNDS[name]) return;
  if (Array.isArray(window.__RZ_SOUND_LOG__) && soundOn()) window.__RZ_SOUND_LOG__.push(name);
  if (!soundOn() || document.hidden) return;
  if (name === 'tick') { const now = performance.now(); if (now - lastTick < 45) return; lastTick = now; }
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx ||= new AC();
    if (ctx.state === 'suspended') ctx.resume();
    const t0 = ctx.currentTime + 0.01;
    for (const [f, start, dur, type, gain] of SOUNDS[name]) {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = type; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t0 + start);
      g.gain.exponentialRampToValueAtTime(gain, t0 + start + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + start + dur);
      o.connect(g).connect(ctx.destination);
      o.start(t0 + start); o.stop(t0 + start + dur + 0.02);
    }
  } catch { /* audio is a nicety; never break the page */ }
}
